import { DictionaryLink } from "../../../rest/models"
import { Button } from "../../RequestRespectingInputs";
import { selectedWordClass } from "./RenderSentenceTranslation";

export function RenderDictionaryLink(props: {dl: DictionaryLink})
{
    const dl = props.dl
    return <Button
            className='ernots_DictLinkButton'
            key={dl.key}
            onClick={e => getDefinitionUrl(dl.urlpattern)}>
        {dl.text}
    </Button>;
}

function getDefinitionUrl(urlpattern: string)
{
    
    let selectedText = (window.getSelection() ?? '').toString();
    if (!selectedText)
    {
        selectedText = document
            .querySelector('.' + selectedWordClass)
            ?.textContent
            ?? '';
    }

    const escapedText = encodeURIComponent(selectedText)
    const escapedTextLC = encodeURIComponent(selectedText.toLowerCase())

    if (selectedText)
    {
        const url = urlpattern
            .replace('{1}', escapedText)
            .replace('{2}', escapedTextLC);
        window.open(url, '_blank');
    }
}